<div class="text-center">
  <img src="./assets/Images/Logo2.svg" alt="Logo" />
</div>
<p class="log-out" (click)="logout()">
  <i class="icon-upload mr-2"></i>Ausloggen
</p>
<div class="mobile-response d-flex justify-content-center gap-2">
  <div class="first-layer-card-wrapper d-flex justify-content-center gap-2">
    <div class="card first-layer-card">
      <div class="card-body p-0">
        @if (!isUploading && !isUploadFinished && !isCurrentUpload) {
          <h4 class="mb-0">Neu hochladen für {{ tenantName }}</h4>
          @if (isError) {
            <div
              style="margin-top: 1.75rem"
              class="validation-card"
              >
              <i class="icon-exclamation-circle position-absolute"></i>
              <span style="margin-left: 1.5rem"
                >Falsche Email oder falsches Passwort</span
                >
              </div>
            }
            <form [formGroup]="uploadForm" class="mt-4 mb-0">
              @if (!email) {
                <label class="form-label w-100 mb-0">
                  Uploadname<i class="required">*</i
                  ><i
                  class="icon-info-o ms-2 position-relative"
                  tooltip="Dieses Feld darf nicht leer sein or Folgende Zeichen sind nicht erlaubt @#$%^&*!?+=<>[]{}()/\&quot;';:"
                ></i>
                <input
                  type="text"
                  formControlName="name"
                  class="form-control"
                  [ngClass]="
                    isError ||
                    (uploadForm.get('name')!.invalid &&
                      uploadForm.get('name')!.touched)
                      ? 'invalid'
                      : ''
                  "
                  [style]="
                    uploadForm.get('name')!.invalid &&
                    uploadForm.get('name')!.touched
                      ? 'padding-left: 2.25rem;'
                      : ''
                  "
                  />
                @if (
                  uploadForm.get('name')!.invalid &&
                  uploadForm.get('name')!.touched
                  ) {
                  <i
                    class="icon-cancel"
                  ></i>
                }
                @if (
                  uploadForm.get('name')!.hasError('required') &&
                  uploadForm.get('name')!.touched
                  ) {
                  <span
                    class="mb-3 validation-error"
                    >Dieses Feld ist erforderlich.</span
                    >
                  }
                  @if (
                    uploadForm.get('name')?.invalid &&
                    uploadForm.get('name')?.errors?.['nameExist']
                    ) {
                    <span
                      class="mb-3 validation-error"
                      >Der Upload-Name existiert bereits. Bitte wählen Sie einen
                      eindeutigen Namen aus.</span
                      >
                    }
                    @if (
                      uploadForm.get('name')?.invalid &&
                      uploadForm.get('name')?.hasError('pattern')
                      ) {
                      <span
                        class="mb-3 validation-error"
                        >{{
                        'Die folgenden Zeichen und Leerzeichen sind nicht erlaubt @#$%^&*!?+=<>[]{}()/\\"\';:'
                        }}</span
                        >
                      }
                    </label>
                    <label class="form-label w-100 mt-4 mb-0">
                      Datentyp<i class="required">*</i>
                      <ngx-select
                        formControlName="dataType"
                        [noAutoComplete]="true"
                        [items]="uploadDataTypeOptions"
                        optionValueField="value"
                        optionTextField="label"
                        (select)="chooseDataType($event)"
                      ></ngx-select>
                    </label>
                    @if (isTypeAvailable) {
                      <label class="form-label w-100 mt-4 mb-0">
                        Typ<i class="required">*</i>
                        <ngx-select
                          formControlName="type"
                          [noAutoComplete]="true"
                  [items]="
                    uploadForm.get('dataType')?.value === UploadDataType.Survey
                      ? surveyTypeOptions
                      : uploadFileTypeOptions
                  "
                          optionValueField="value"
                          optionTextField="label"
                        ></ngx-select>
                      </label>
                    }
                    @if (isContractNameAvailable) {
                      <label
                        class="form-label w-100 mt-4 mb-0"
                        >
                        Auftragsbezeichnung
                        <i
                          class="icon-info-o ms-2 position-relative"
                          tooltip="Dieses Feld darf nicht leer sein or Folgende Zeichen sind nicht erlaubt @#$%^&*!?+=<>[]{}()/\&quot;';:"
                        ></i>
                        <input
                          type="text"
                          formControlName="contractName"
                          class="form-control"
                  [ngClass]="
                    isError ||
                    (uploadForm.get('contractName')!.invalid &&
                      uploadForm.get('contractName')!.touched)
                      ? 'invalid'
                      : ''
                  "
                  [style]="
                    uploadForm.get('contractName')!.invalid &&
                    uploadForm.get('contractName')!.touched
                      ? 'padding-left: 2.25rem;'
                      : ''
                  "
                          />
                        @if (
                          uploadForm.get('contractName')!.invalid &&
                          uploadForm.get('contractName')!.touched
                          ) {
                          <i
                            class="icon-cancel"
                          ></i>
                        }
                        @if (
                          uploadForm.get('contractName')?.invalid &&
                          uploadForm.get('contractName')?.hasError('pattern')
                          ) {
                          <span
                            class="mb-3 validation-error"
                            >{{
                            'Die folgenden Zeichen und Leerzeichen sind nicht erlaubt @#$%^&*!?+=<>[]{}()/\\"\';:'
                            }}</span
                            >
                          }
                        </label>
                      }
                      @if (isProjectField) {
                        <label class="form-label w-100 mt-4 mb-0">
                          Projekt (optional)
                          <input
                            type="text"
                            formControlName="project"
                            class="form-control"
                            />
                        </label>
                      }
                      <label class="form-label w-100 mt-4 mb-4">
                        Kommentar
                        <input
                          type="text"
                          formControlName="comment"
                          class="form-control"
                          />
                      </label>
                      <!--              <app-drag-and-drop *ngIf="notUploadedStructureFlat.length === 0"-->
                      <!--                text="Ordner auswählen oder hierher ziehen und ablegen" [allowDirectorySelection]="!isTablet"-->
                      <!--                [isAllowFoldersAndFiles]="isAllowFoldersAndFiles" buttonText="Ordner auswählen"-->
                      <!--                (onChangeFileFolderAccept)="changeFileFolderAccept($event)"-->
                    <!--                (addedFiles)="isTablet || isFileDragOver ? onFileReChange($event, this.uploadForm.get('name')?.value ? this.uploadForm.get('name')?.value + '/' : this.uploadForm.get('name')?.value) : onFileReChange($event)"></app-drag-and-drop>-->
                    @if (notUploadedStructureFlat.length === 0) {
                      <div
                        class="file form-group files w-100 mt-4"
                [ngClass]="
                  currentFiles.length > 0 || uploadModel?.files!.length > 0
                    ? 'upload-container-with-files'
                    : 'upload-container-without-files'
                "
                        (dragenter)="detectFilesOrFolder($event)"
                        [style]="isDisabledUploading ? 'opacity:0.4' : ''"
                        [tooltip]="isDisabledUploading ? 'Wählen Sie den Datentyp' : ''"
                        >
                        <div class="file-description">
                          <img class="upload-image" src="./assets/Images/upload.png" />
                          <div class="mt-2" style="font-size: 13px; font-weight: 400">
                            Ordner auswählen oder hierher ziehen und ablegen
                          </div>
                          @if (!isAllowFoldersAndFiles || isTablet) {
                            <button
                              class="btn btn-secondary btn-lg mt-2"
                              >
                              Ordner auswählen
                            </button>
                          }
                          @if (isAllowFoldersAndFiles && !isTablet) {
                            <div
                              class="d-flex mt-2 gap-2"
                              >
                              @if (!currentFiles.length || isFileDragOver) {
                                <button
                                  class="btn btn-secondary btn-lg z-1"
                                  (click)="fileInput?.nativeElement.click()"
                                  >
                                  Dateien auswählen
                                </button>
                              }
                              @if (!currentFiles.length || !isFileDragOver) {
                                <button
                                  class="btn btn-secondary btn-lg z-1"
                                  (click)="folderInput?.nativeElement.click()"
                                  >
                                  Ordner auswählen
                                </button>
                              }
                            </div>
                          }
                        </div>
                        @if (!isAllowFoldersAndFiles || isTablet) {
                          @if (isTablet) {
                            <input
                              type="file"
                              name="file"
                              class="form-control w-100 h-100"
                              [style]="isDisabledUploading ? 'cursor:not-allowed' : ''"
                              (change)="onFileChangeAllAllow($event, true)"
                              multiple
                              />
                          }
                          @if (!isTablet) {
                            <input
                              type="file"
                              name="file"
                              class="form-control w-100 h-100"
                              [style]="isDisabledUploading ? 'cursor:not-allowed' : ''"
                              [disabled]="isDisabledUploading"
                              (change)="onFileChange($event)"
                              webkitdirectory
                              directory
                              />
                          }
                        }
                        @if (isAllowFoldersAndFiles && !isTablet) {
                          <input
                            type="file"
                            name="file"
                            class="form-control w-100 h-100 cursor-auto"
                            [ngClass]="isDragingOver ? 'd-block' : 'd-none'"
                            [attr.multiple]="isFileDragOver ? '' : null"
                            [attr.webkitdirectory]="!isFileDragOver ? '' : null"
                            [attr.directory]="!isFileDragOver ? '' : null"
                            (dragleave)="stopDragOver()"
                            (change)="onFileChangeAllAllowDragDrop($event)"
                            />
                          <input
                            #fileInput
                            type="file"
                            name="file"
                            class="d-none"
                            (change)="onFileChangeAllAllow($event, true)"
                            multiple
                            />
                          <input
                            #folderInput
                            type="file"
                            name="file"
                            class="d-none"
                            (change)="onFileChangeAllAllow($event, false)"
                            webkitdirectory
                            directory
                            />
                        }
                      </div>
                    }
                  }
                </form>
              }

              @if (isCurrentUpload && !isUploading && !isUploadFinished) {
                <div
                  style="margin-top: 1.75rem"
                  class="validation-card mt-4"
                  >
                  <i class="icon-exclamation-circle"></i>
                  <p class="mb-0">
                    Einige Dateien wurden nicht hochgeladen. Wählen Sie denselben Ordner
                    <b>{{ rootFolderName }}</b> wie beim ersten Upload
                  </p>
                </div>
              }

              @if (notUploadedStructure.length) {
                <div
                  class="uploading-files"
                  [ngClass]="{ uploading: isUploading, finished: isUploadFinished }"
                  >
                  @if (isUploading) {
                    <h5 class="mb-0">Hochladen</h5>
                    <!-- <small *ngIf="currentFiles.length > 0" class="d-block" style="margin-top: 1.25rem;">Warten auf Upload</small> -->
                    @if (
                      isUploading || (uploadFileService.isFilesUploading$ | async)
                      ) {
                      <div
                        class="mt-3"
                        >
                        <span class="current-file"
                          ><span
                          >{{
                          uploadFileService.filesAlreadyUpload$ | async | fileSize
                          }}
                          von
                          {{
                          uploadFileService.filesShouldUpload$ | async | fileSize
                          }}</span
                          >
                          Dateien erfolgreich hochgeladen</span
                          >
                          <div class="progress mt-2 custom-progress">
                            <div
                              class="progress-bar bg-dark"
                              role="progressbar"
                              [style.width.%]="progressPercent"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                            <div class="progress-label">
                              {{ progressPercent | number: '1.0-0' }}%
                            </div>
                          </div>
                          @if (uploadFileService.isForgeProcessing$ | async) {
                            <div class="d-flex align-items-center justify-content-center mt-3 gap-2">
                              <span class="spinner-border spinner-border-sm text-secondary"></span>
                              <small class="text-muted">3D-Modell wird vorbereitet, bitte warten...</small>
                            </div>
                          }
                        </div>
                      }
                    }
                    @if (isUploadFinished) {
                      <div class="text-center mt-4">
                        @if (isLastUploadStopped) {
                          <img class="done-logo" src="./assets/Images/partially-done.svg" />
                          <h3 class="mt-3 mb-0 finished-title">
                            Der Upload ist teilweise abgeschlossen
                          </h3>
                          <small class="finished-text"
                            >{{
                            uploadFileService.filesAlreadyUpload$ | async | fileSize
                            }}
                            Dateien von
                            {{
                            uploadFileService.filesShouldUpload$ | async | fileSize
                            }}
                            Dateien erfolgreich hochgeladen</small
                            >
                            <button
                              type="button"
                              class="btn btn-primary mt-3 px-4 py-2 mb-5"
                              (click)="newUpload()"
                              >
                              Neuer Upload
                            </button>
                          } @else {
                            <span class="icon-check-circle"></span>
                            <h3 class="mt-3 mb-0 finished-title">
                              Der Upload wurde abgeschlossen
                            </h3>
                            <small class="finished-text"
                              >{{
                              uploadFileService.filesAlreadyUpload$ | async | fileSize
                              }}
                              Dateien von
                              {{
                              uploadFileService.filesShouldUpload$ | async | fileSize
                              }}
                              Dateien erfolgreich hochgeladen</small
                              >
                              <button
                                type="button"
                                class="btn btn-primary mt-3 px-4 py-2 mb-5"
                                (click)="newUpload()"
                                >
                                Neuer Upload
                              </button>
                            }
                          </div>
                        }
                        <!-- <p class="uploaded-files-title">{{isUploadFinished ? 'HOCHGELADENE DATEIEN' : 'WARTEN AUF UPLOAD'}}</p> -->
                        <div class="containter-place mt-4 list-overflow">
                          <ul
                            class="position-relative ps-0 height-uploaded-files"
                            (dragover)="detectFilesOrFolder($event)"
                            (drop)="onFileDrop($event)"
                            (dragleave)="stopDragOver()"
                            >
                            <cdk-virtual-scroll-viewport
                              itemSize="26"
                              class="containter-place"
                              >
                              <li
                  *cdkVirtualFor="
                    let item of notUploadedStructureFlat | visibleFlatStructure
                  " data-tooltip-no-anchor
                                class="mt-0 d-flex flex-column"
                                >
                                <ng-container
                    [ngTemplateOutlet]="
                      item.type === 'file' ? fileFlat : folderFlat
                    "
                    [ngTemplateOutletContext]="{
                      item: item,
                      parentPath: item.path,
                      isAllowDelete: true,
                    }"
                                  >
                                </ng-container>
                              </li>
                            </cdk-virtual-scroll-viewport>
                          </ul>
                        </div>
                      </div>
                    }

                    @if (!isUploadFinished) {
                      <div class="card-footer pt-3 pb-0">
                        <div class="d-flex justify-content-end w-100">
                          @if (isUploading) {
                            <button
                              class="btn btn-secondary mr-auto"
                              (click)="cancelAndDeleteUpload()"
                              >
                              Abbrechen
                            </button>
                          }
                          @if (isUploading) {
                            <button
                              class="btn btn-secondary px-4"
                              (click)="cancelUpload()"
                              >
                              Pause
                            </button>
                          }
                          @if (!isPartially || currentFiles.length) {
                            <button
                              class="btn btn-primary px-4"
                              style="margin-left: 0.75rem"
                              (click)="upload()"
              [disabled]="
                !notUploadedStructure.length ||
                (uploadForm.invalid && !isPartially) ||
                (isPartially && !currentFiles.length) ||
                isChekingUnique ||
                isUploading
              "
                              >
                              Upload
                            </button>
                          }
                          @if (isPartially && !currentFiles.length) {
                            <button
                              class="btn btn-link btn-text-blue px-4"
                              (click)="changeUploadStatusToUploaded()"
                              >
                              Ignorieren
                            </button>
                          }
                          @if (isPartially && !currentFiles.length) {
                            @if (
                              isTablet ||
                              !(
                              uploadForm.get('dataType')?.value ===
                              UploadDataType.ConstructionSite ||
                              uploadForm.get('dataType')?.value ===
                              UploadDataType.Survey ||
                              uploadForm.get('dataType')?.value ===
                              UploadDataType.Hydrodynamic
                              )
                              ) {
                              <div
                                class="file btn btn-primary px-4"
                                >
                                {{ isTablet ? 'Dateien auswählen' : 'Ordner auswählen' }}
                                @if (!isTablet) {
                                  <input
                                    type="file"
                                    name="file"
                                    (change)="onFileChange($event)"
                                    webkitdirectory
                                    directory
                                    />
                                }
                                @if (isTablet) {
                                  <input
                                    type="file"
                                    name="file"
                  (change)="
                    selectFolderLocatedFiles($event, templateSelectFolder)
                  "
                                    multiple
                                    />
                                }
                              </div>
                            }
                            @if (
                              !isTablet &&
                              (uploadForm.get('dataType')?.value ===
                              UploadDataType.ConstructionSite ||
                              uploadForm.get('dataType')?.value ===
                              UploadDataType.Survey ||
                              uploadForm.get('dataType')?.value ===
                              UploadDataType.Hydrodynamic)
                              ) {
                              <div class="file btn btn-primary px-2 mr-2">
                                Dateien auswählen
                                <input
                                  type="file"
                                  name="file"
                                  (change)="onFileChange($event)"
                                  webkitdirectory
                                  directory
                                  />
                              </div>
                              <div class="file btn btn-primary px-2">
                                Ordner auswählen
                                <input
                                  type="file"
                                  name="file"
                    (change)="
                      selectFolderLocatedFiles($event, templateSelectFolder)
                    "
                                  multiple
                                  />
                              </div>
                            }
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
                @if (history.length && !notUploadedStructure.length) {
                  <div
                    class="card first-layer-card card-overflow"
                    >
                    <div class="card-body p-0">
                      <h4>Vorherige Uploads</h4>
                      <div class="d-flex mt-4 mb-4">
                        <div class="d-inline-block mr-2 user-limit">
                          <div
                            [style.--progress-value]="sizeOfFiles / MAX_SIZE_OF_FILES_POOL"
                            [ngStyle]="{ to: MAX_SIZE_OF_FILES_POOL }"
                            class="black-orientation progress-bar"
                            >
                            <progress id="html" min="0" max="100" value="100"></progress>
                            <span class="progressbar__text"
                              >{{ (sizeOfFiles / MAX_SIZE_OF_FILES_POOL).toFixed(1) }}%</span
                              >
                            </div>
                          </div>
                          <p class="uploaded-file-size my-auto">
                            {{ sizeOfFiles | fileSize }} von 250 GB des Speichers sind belegt
                          </p>
                        </div>
                        @for (upload of history; track upload) {
                          <div class="card history-card-item mt-2" data-tooltip-no-anchor>
                            <div
                              (click)="openHistoryItem(upload.array[0])"
                              class="d-flex justify-content-between"
                              >
                              <div class="d-flex card-text info-title">
                                <p class="name">{{ upload.displayName }}</p>
                                <p class="m-0 history-date">
                                  {{
                                  upload.array[0].uploadDate + 'Z'
                                  | date: 'dd. MMM y HH:mm' : '' : 'de-DE'
                                  }}
                                </p>
                              </div>
                              <div class="d-flex justify-content-end align-items-center ml--2">
                                @if (getUploadStatus(upload.array[0]) === Status.Partially) {
                                  <button
                                    class="btn btn-link p-0"
                                    (click)="reupload($event, upload.array[0])"
                                    >
                                    Upload fortsetzen
                                  </button>
                                }
                                <i
                [ngClass]="
                  upload.array[0].isOpen
                    ? 'icon-caret-down'
                    : 'icon-caret-right'
                "
                                ></i>
                              </div>
                            </div>
                            @if (upload.array[0].isOpen) {
                              <div class="overflow-container">
                                <div class="containter-place mt-4 list-overflow">
                                  @if (upload && upload.array[0].filesStructureFlat) {
                                    <ul
                                      class="position-relative ps-0"
                                      >
                                      <cdk-virtual-scroll-viewport
                                        itemSize="26"
                                        class="containter-place"
                                        style="height: 16vh"
                                        >
                                        <li
                    *cdkVirtualFor="
                      let item of upload.array[0].filesStructureFlat
                        | visibleFlatStructure
                    " data-tooltip-no-anchor
                                          class="mt-0 d-flex flex-column"
                                          >
                                          <ng-container
                      [ngTemplateOutlet]="
                        item.type === 'file' ? fileFlat : folderFlat
                      "
                      [ngTemplateOutletContext]="{
                        item: item,
                        parentPath: item.path,
                      }"
                                            >
                                          </ng-container>
                                        </li>
                                      </cdk-virtual-scroll-viewport>
                                    </ul>
                                  }
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              </div>

              <ng-template #folderFlat let-item="item" let-isAllowDelete="isAllowDelete">
                <div class="ellipsis" [style.paddingLeft.px]="item.level * 16">
                  <span (click)="item.isOpen = !item.isOpen">
                    <span
                      class="pdf-small-icon"
                      [ngClass]="item.isOpen ? 'icon-caret-down' : 'icon-caret-up'"
                    ></span>
                    <span class="fa fa-folder-o pdf-small-icon position-relative">
                      <span
                        class="dot"
                        [ngClass]="foldersWithMissingFiles.has(item.path) ? 'unadded' : 'added'"
                      ></span>
                    </span>
                    <span class="file-path ellipsis ml-1">{{ item.name }}</span>
                  </span>
                </div>
              </ng-template>

              <ng-template
                #fileFlat
                let-item="item"
                let-parentPath="parentPath"
                let-isAllowDelete="isAllowDelete"
                >
                <div class="ml-3 ellipsis" [style.paddingLeft.px]="item.level * 16">
                  <span
      class="{{
        item.name.split('.').pop() | iconByExtantion
      }} pdf-small-icon position-relative"
                    >
                    <span
                      class="dot"
                      [ngClass]="!isUploadedFiles(item.path) ? 'added' : 'unadded'"
                    ></span>
                  </span>
                  <span class="file-path ellipsis ml-1">{{ item.name }}</span>
                  @if ((currentFiles.length || isUploadFinished) && !item.isAdded) {
                    <span class="gray">(Die Datei fehlt)</span>
                    <span class="file icon-refresh ml-1">
                      <input
                        type="file"
                        name="file"
                        class="icon-input"
                        (change)="onFileChange($event, parentPath)"
                        />
                    </span>
                  }
                  @if (item.isUploaded) {
                    <span class="icon-check"></span>
                  }
                  @if (
                    isAllowDelete &&
                    !isUploading &&
                    item.isAdded &&
                    !isUploadFinished &&
                    item.name.split('.').pop()?.toLocaleLowerCase() !== 'xml' &&
                    (item.name.split('.').pop()?.toLocaleLowerCase() !== 'iml' ||
                    (uploadForm.get('dataType')?.value !== UploadDataType.Cleaning &&
                    uploadForm.get('dataType')?.value !== UploadDataType.TVInspection))
                    ) {
                    <span
                      class="icon-delete delete-structure ml-1"
                      (click)="removeFileStructure(item)"
                    ></span>
                  }
                </div>
              </ng-template>

              <ng-template #templateSelectFolder>
                <div class="modal-body">
                  <span class="header-modal" style="font-weight: 700; font-size: 20px"
                    >Dateien auswählen</span
                    >
                    <p>Wählen Sie die gleichen Dateien wie beim ersten Upload.</p>
                    <ul class="ps-0">
                      @for (path of notUploadedFolderPaths; track path) {
                        <li
                          data-tooltip-no-anchor
                          (click)="submitSelectFolder(path)"
                          >
                          <b>{{ path }}</b>
                        </li>
                      }
                    </ul>
                    <div class="float-end w-100 mt-4">
                      <button
                        type="button"
                        class="btn btn-link btn-secondary w-100"
                        (click)="submitSelectFolder('')"
                        >
                        Schließen
                      </button>
                    </div>
                  </div>
                </ng-template>
